export default __webpack_public_path__ + "static/media/datav2front.7d43ba11.jpg";